/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Google_Analytics_DescriptionInputs */

const en_admin_settings_groups_google_analytics_description = /** @type {(inputs: Admin_Settings_Groups_Google_Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inject gtag.js with the configured Measurement ID`)
};

/**
* | output |
* | --- |
* | "Inject gtag.js with the configured Measurement ID" |
*
* @param {Admin_Settings_Groups_Google_Analytics_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_google_analytics_description = /** @type {((inputs?: Admin_Settings_Groups_Google_Analytics_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Google_Analytics_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_google_analytics_description(inputs)
});
export { admin_settings_groups_google_analytics_description as "admin.settings.groups.google_analytics.description" }